import React, { useEffect, useRef, useState } from 'react';
import { Coins } from 'lucide-react';
import { useLiveCoins, useCoinFlash } from '../context/GameContext';

// Self-contained balance pill: subscribes to the external coin store so
// the 1Hz exhibit drip re-renders ONLY this tiny component, not the
// whole page. Handles the pulse ring, floating "+N" and haptic burst.
export const LiveCoinPill = ({ size = 'sm' }) => {
  const liveCoins = useLiveCoins();
  const flash = useCoinFlash();
  const [pulse, setPulse] = useState(false);
  const [floating, setFloating] = useState(null);
  const seenSeqRef = useRef(flash.seq);

  useEffect(() => {
    if (flash.seq === seenSeqRef.current) return;
    seenSeqRef.current = flash.seq;
    if (!flash.amount || flash.amount <= 0) return;
    setPulse(true);
    const t1 = setTimeout(() => setPulse(false), 800);
    setFloating(flash.amount);
    const t2 = setTimeout(() => setFloating(null), 1500);
    if (flash.haptic) {
      const tg = window.Telegram?.WebApp;
      if (tg?.HapticFeedback) {
        tg.HapticFeedback.impactOccurred('light');
        setTimeout(() => tg.HapticFeedback.impactOccurred('light'), 150);
        setTimeout(() => tg.HapticFeedback.impactOccurred('medium'), 350);
      }
    }
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [flash]);

  const textSize = size === 'lg' ? 'text-lg' : 'text-sm';
  return (
    <div className="relative" data-testid="live-coin-pill">
      <div className={`flex items-center gap-1.5 glass-card px-3 py-1.5 rounded-full cursor-pointer transition-all duration-300 ${
        pulse ? 'scale-110 ring-2 ring-[#D4AF37]/60 bg-[#D4AF37]/15' : ''
      }`}>
        <Coins className={`w-4 h-4 text-[#D4AF37] transition-transform duration-300 ${pulse ? 'scale-125' : ''}`} />
        <span
          data-testid="live-coin-value"
          className={`font-mono ${textSize} tabular-nums transition-colors duration-300 ${pulse ? 'text-[#D4AF37]' : ''}`}
        >
          {liveCoins.toLocaleString()}
        </span>
      </div>
      {floating && (
        <div className="absolute -top-1 left-1/2 -translate-x-1/2 pointer-events-none animate-coin-float z-50">
          <span className="text-sm font-bold text-[#10B981] drop-shadow-lg">+{floating}</span>
        </div>
      )}
    </div>
  );
};

export default LiveCoinPill;
